import { DateTime } from "luxon";

export const ENCOUNTER_CREATED_ACTIVITY_TYPE = "Encounter Created";

export type EncounterCreationSource =
  | "clinic-new-schedule"
  | "engage-new-schedule"
  | "engage-prospect-schedule"
  | "engage-schedule-panel"
  | "follow-up";

export const ENCOUNTER_CREATION_SOURCE_LABELS: Record<
  EncounterCreationSource,
  string
> = {
  "clinic-new-schedule": "Clinic — New Schedule",
  "engage-new-schedule": "Engage — New Schedule",
  "engage-prospect-schedule": "Engage — Prospect Schedule",
  "engage-schedule-panel": "Engage — Schedule",
  "follow-up": "Encounter — Follow-Up",
};

export function buildEncounterCreatedNurseNoteSummary(input: {
  createdBy: string;
  source: EncounterCreationSource;
  createdAt?: Date | string;
}): string {
  const createdBy = (input.createdBy || "Unknown user").trim() || "Unknown user";
  const sourceLabel =
    ENCOUNTER_CREATION_SOURCE_LABELS[input.source] || input.source;
  const when = formatEncounterCreatedTimestamp(input.createdAt);
  return `Encounter created by ${createdBy} on ${when} via ${sourceLabel}.`;
}

function formatEncounterCreatedTimestamp(value?: Date | string): string {
  if (!value) {
    return DateTime.now().toFormat("MMM d, yyyy 'at' h:mm a");
  }
  const dt =
    value instanceof Date
      ? DateTime.fromJSDate(value)
      : DateTime.fromISO(String(value));
  if (!dt.isValid) {
    return DateTime.now().toFormat("MMM d, yyyy 'at' h:mm a");
  }
  return dt.toFormat("MMM d, yyyy 'at' h:mm a");
}
